import { ALL_RESULTS, translate } from "shared/utils/translate";
import { Button } from "shared/components/Button";
import { CloseIcon, ChevronIcon } from "shared/components/Icons";
import { MaxWidth } from "shared/components/MaxWidth";
import { SEARCH_TYPE, SMALL, LARGE, TYPE_LINK } from "shared/utils/constants";
import { SearchInput } from "clariah/components/SearchInput";
import { SearchResultLive } from "clariah/components/SearchResultLive";
import { useRouter } from "next/router";
import { useSearch } from "clariah/utils/useSearch";
import styles from "./SearchBar.module.css";

export const SearchBar = ({ setSearchOpen, query, setQuery }) => {
  const { locale } = useRouter();
  const results = useSearch(query.length > 2 ? query : "", locale);

  return (
    <div>
      <MaxWidth size={LARGE}>
        <div className={styles.searchBar}>
          <button
            className={styles.closeButton}
            onClick={() => setSearchOpen(false)}
          >
            <ChevronIcon />
          </button>
          <div className={styles.searchInputContainer}>
            <SearchInput inBar query={query} setQuery={setQuery} />
          </div>
          <button
            className={styles.closeButton}
            onClick={() => setSearchOpen(false)}
          >
            <CloseIcon />
          </button>
        </div>
      </MaxWidth>
      {results.length > 0 && (
        <div className={styles.searchResults}>
          <MaxWidth size={SMALL}>
            {results.slice(0, 5).map((data) => (
              <SearchResultLive key={data.href} {...data} />
            ))}
            {results.length > 5 && (
              <div className={styles.allButtonContainer}>
                <Button
                  href={`?q=${query}`}
                  hrefType={SEARCH_TYPE}
                  type={TYPE_LINK}
                >
                  {translate(ALL_RESULTS, locale)} ({results.length})
                </Button>
              </div>
            )}
          </MaxWidth>
        </div>
      )}
    </div>
  );
};
